import * as Msal from 'msal'
import config from '../config'

export default class AuthService {
  constructor() {
    this.applicationConfig = {
      clientID: config.clientid,
      authority: config.authority
    }
    var t = ""
    this.app = new Msal.UserAgentApplication(this.applicationConfig.clientID,this.applicationConfig.authority,
    function (errorDesc, token, error, tokenType) {
        t = token     
        if(t){
          window.location.href = 'https://sisat.sma.gob.cl/lena?t='+t;
        }
    },
    {    
      validateAuthority: false,
      navigateToLoginRequestUrl:false,
    })
  }
  login() {
    this.app.loginRedirect()         
  }
   
  logout() {
    this.app._user = null
    this.app.logout()
  }

  getUser() {
    return this.app.getUser()
  }

  isLogin(){
    let estado = false
    if (this.app.getUser()) {
      estado = true
    }
    return estado
  }  
}



// WEBPACK FOOTER //
// ./src/msal/index.js